import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import ThemeProvider from '@/modules/theme/ThemeProvider';
import AppRoutes from '@/router';
import { store } from '@/store';

const App = () => (
    <ThemeProvider>
        <Provider store={store}>
            <BrowserRouter>
                <AppRoutes/>
            </BrowserRouter>
        </Provider>
    </ThemeProvider>
);

export default App;
